import type {
  BuildPhase,
  PhaseBuildExecutionState,
} from '../../services/buildPhaseService';

import { api } from './api';

export interface PhaseBuildStateQuery {
  projectId: string;
  modelTier: string;
}

/**
 * Shared phase metadata and execution state.
 *
 * A five-minute unused-data window avoids resetting the Kanban scope to
 * "All Tasks" when users switch task views and return.
 */
export const phaseBuildApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getBuildPhases: builder.query<BuildPhase[], string>({
      query: (projectId) => `/api/v1/projects/${projectId}/build-phases`,
      keepUnusedDataFor: 300,
      providesTags: (_result, _error, projectId) => [
        { type: 'BuildPhases' as const, id: projectId },
      ],
    }),
    getPhaseBuildState: builder.query<PhaseBuildExecutionState, PhaseBuildStateQuery>({
      query: ({ projectId, modelTier }) => ({
        url: `/api/v1/projects/${projectId}/build-phases/execution-state`,
        params: { model_tier: modelTier },
      }),
      keepUnusedDataFor: 300,
      providesTags: (_result, _error, { projectId, modelTier }) => [
        { type: 'PhaseBuildState' as const, id: `${projectId}:${modelTier}` },
      ],
    }),
  }),
});

export const {
  useGetBuildPhasesQuery,
  useGetPhaseBuildStateQuery,
} = phaseBuildApi;
